import ManualAdditionSaman from "@/pages/DigitalAccount/Saman/Create/ManualAdditionSaman";
import { LegacyCard } from "@payping/web-components";
import { FormInstance } from "@payping/web-components/legacyComponents/Form/types";
import React from "react";
import { SamanRowType } from "@/pages/DigitalAccount/Saman/Create/SecondStep";

interface Props {
  form: FormInstance<SamanRowType>;
}

const ManualRequestSaman: React.FC<Props> = ({ form }) => {
  return (
    <LegacyCard.Ant>
      <ManualAdditionSaman form={form} />
    </LegacyCard.Ant>
  );
};

export default ManualRequestSaman;
